import React, { useState, useCallback, useContext, useEffect } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import SimpleBar from 'simplebar-react';

import { AppContext } from '../common/contexts';
// import { LayoutContext } from '../common/contexts';
import { setClassNameInDefns } from '../common/definitionHelper';
// import { getCalendarFirstDay, createMonthlyCalendarData } from '../common/calendarHelper';
// import { CALENDAR_TYPE_MONTH, CALENDAR_TYPE_WEEK } from '../common/constants';
import { handleCloseSnackbar } from '../common/snackbarHelper';
import AfitdTypography from '../common/elemental/AfitdTypography';
import AfitdTextField from '../common/elemental/AfitdTextField';
import AfitdSnackbar from '../common/elemental/AfitdSnackbar';
// import AfitdTypography from '../common/elemental/AfitdTypography';
// import AfitdAutocompleteLite from '../common/elemental/AfitdAutocompleteLite';
import AfitdAutocomplete from '../common/elemental/AfitdAutocomplete';
import JoinInterviewButtonTEMP from '../empDashboardMyCalendar/subComponents/JoinInterviewButtonTEMP';
import PageMessage from '../common/elemental/PageMessage';

import {
    saveInterviewList,
    /*saveMyMessagesThreads,*/ addThreadMessage,
    setUpEmployer,
    beginNewBillCycle,
    memberAcceptEmployerInvite,
    reactivateEmployer,
    pushCollectionToElasticSearch,
    collectionEsSyncServices,
    pushCountriesStatesCitiesToElasticSearchFromJson,
    generatePromoCode,
    showCloudStorageObjectList,
    saveStripeTestClockId,
    // populateSurveyFields,
    sendResetPasswordEmail,
    // generateMonthHiredCandidates,
    // populateAppliedJobs,
    // populateInterviews,
    // populateFeedbacks,
    // fetchCreatableLovCollection,
    // fixDashboardActionNeededPendingInterviews,
    sendWaitListEmails,
    // populateAdWidthCustomers,
    // populateEngagementFields,
    // fixJsEngageCounts,
} from '../common/services/tempAdminServices';

import { importCountriesStatesCities, clearJobRelatedData } from '../common/services/tempAdminServices';

import { addCreatableLovItems, addDynamicDocs, addDynamicData, changeCurrentUserPassword, changeCurrentUserEmail } from '../common/services/tempAdminServices';

// import cx from 'clsx';
// import format from 'date-fns/format';
import _get from 'lodash/get';
// import _set from 'lodash/set';
import _isNil from 'lodash/isNil';

const styles = theme => ({
    root: {
        overflow: 'hidden',
        backgroundColor: '#FFFFFF',
        padding: '24px',
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
    },
    fieldContainer: {
        maxHeight: '500px',
        padding: '24px',
        overflow: 'hidden',
    },
    buttonContainer: {
        margin: '12px 0',
    },
    threadIdContainer: { marginBottom: '30px' },
});

const defaultInterviewsJson = [
    {
        companyName: 'XXXXXXXXXX',
        jobTitle: 'YYYYYYYYYYY',
        pocName: 'XXXXXXXXXX',
        interviewStartDate: '10/15/2020',
        interviewStartTime: '0000',
        interviewEndDate: '10/15/2020',
        interviewEndTime: '0000',
        virtual: true,
        jobSeekerId: '5uX46DTNCqe9YGtNMSxv2vItm8A2',
        jobSeekerName: 'Test Wick',
        status: 'PENDING',
        streetAddress1: '',
        streetAddress2: '',
        city: '',
        state: '',
        postalCode: '',
    },
    {
        companyName: 'XXXXXXXXXX',
        jobTitle: 'YYYYYYYYYYY',
        pocName: 'XXXXXXXXXX',
        interviewStartDate: '10/15/2020',
        interviewStartTime: '0000',
        interviewEndDate: '10/15/2020',
        interviewEndTime: '0000',
        virtual: true,
        jobSeekerId: '5uX46DTNCqe9YGtNMSxv2vItm8A2',
        jobSeekerName: 'Test Wick',
        status: 'PENDING',
        bucket: 'JS',
        streetAddress1: '',
        streetAddress2: '',
        city: '',
        state: '',
        postalCode: '',
    },
];

const defaultMyMessagesJson = {
    tiers: [
        {
            activeJobMax: 3,
            jsEngageMax: 20, //number of candidates engagement limit
            priceMo: 499,
            priceYr: 5389,
            seatMax: 1, //number of seats limit
            tier: 1,
        },
        {
            activeJobMax: 7,
            jsEngageMax: 60, //number of candidates engagement limit
            priceMo: 999,
            priceYr: 10789,
            seatMax: 3, //number of seats limit
            tier: 2,
        },
        {
            // jsEngageMax: -1, //number of candidates engagement limit
            priceMo: 1499,
            priceYr: 16189,
            seatMax: 10, //number of seats limit
            seatPrice: 199, // price for each additional seat. Tier 3 only.
            tier: 3,
        },
    ],
    messages: [
        {
            createDate: '08/08/2020',
            createTime: '1300',
            // jobSeekerId: string,
            employerId: 'EMPLOYER000001',
            content: "Hello! Let's meet!",
            // attachment: {
            //   url: string,
            //   title: string,
            //   type: string,
            //   size: number
            // }
        },
        {
            createDate: '08/08/2020',
            createTime: '1315',
            jobSeekerId: 'ekOVkRuQj1evtfnLsoHVfyeia632',
            // employerId: string,
            content: "There's no spoon!",
            // attachment: {
            //   url: string,
            //   title: string,
            //   type: string,
            //   size: number
            // }
        },
        {
            createDate: '09/09/2020',
            createTime: '1645',
            // jobSeekerId: string,
            employerId: 'EMPLOYER000001',
            content: 'Is there a fork?',
            // attachment: {
            //   url: string,
            //   title: string,
            //   type: string,
            //   size: number
            // }
        },
    ],
    myMessages: {
        jobSeekerId: 'ekOVkRuQj1evtfnLsoHVfyeia632',
        jobSeekerName: 'John Wick',
        // employerId: string,
        // companyName: string,
        threadSummaries: [
            {
                // threadId: string,
                subject: 'Account Manager Retail and E-Commerce',
                jobId: 'JOB000001',
                jobTitle: 'Housekeeper',
                // jobSeekerId: string,
                // jobSeekerName: string,
                // jobSeekerProfileImageUrl: string,
                jobSeekerLastReadDate: '08/09/2020',
                jobSeekerLastReadTime: '1630',
                jobSeekerNewMessagesCount: 0,
                employerId: 'EMPLOYER000001',
                companyName: 'Continental Hotel',
                employerProfileImageUrl:
                    'https://firebasestorage.googleapis.com/v0/b/afitd-dev.appspot.com/o/users%2FEMPLOYER000001%2Fprofile.png?alt=media&token=602226f9-9168-4243-986f-7c321a56bf98',
                // employerLastReadDt: timestamp,
                // employerNewMessagesCount: number,
                lastMessageDate: '08/08/2020',
                lastMessageTime: '1315',
                threadId: 'bm2ONh0ecYB501nshwIQ', //TEST FcoVsZWrCPtoE20bS4A5
            },
            {
                // threadId: string,
                subject: 'Senior Marketing Manager (m/f/d)',
                jobId: 'JOB000002',
                jobTitle: 'Stuntman',
                // jobSeekerId: string,
                // jobSeekerName: string,
                // jobSeekerProfileImageUrl: string,
                jobSeekerLastReadDate: '08/09/2020',
                jobSeekerLastReadTime: '1630',
                jobSeekerNewMessagesCount: 0,
                employerId: 'EMPLOYER000002',
                companyName: 'Pixar',
                employerProfileImageUrl:
                    'https://firebasestorage.googleapis.com/v0/b/afitd-dev.appspot.com/o/users%2FEMPLOYER000002%2Fprofile.png?alt=media&token=1c95fa15-fe78-43aa-b9a1-341c224c59e8',
                // employerLastReadDt: timestamp,
                // employerNewMessagesCount: number,
                lastMessageDate: '08/08/2020',
                lastMessageTime: '1315',
                threadId: 'aHl5XlglmtTOxldDkmlO', //TEST wK5yEJK1cU0wKblUt8rH
            },
        ],
    },
    threadSummary: {
        // threadId: string,
        subject: 'Account Manager Retail and E-Commerce',
        jobId: 'JOB000001',
        jobTitle: 'Housekeeper',
        // jobSeekerId: string,
        // jobSeekerName: string,
        // jobSeekerProfileImageUrl: string,
        jobSeekerLastReadDate: '08/09/2020',
        jobSeekerLastReadTime: '1630',
        jobSeekerNewMessagesCount: 0,
        employerId: 'EMPLOYER000001',
        companyName: 'Continental Hotel',
        employerProfileImageUrl:
            'https://firebasestorage.googleapis.com/v0/b/afitd-dev.appspot.com/o/users%2FEMPLOYER000001%2Fprofile.png?alt=media&token=602226f9-9168-4243-986f-7c321a56bf98',
        // employerLastReadDt: timestamp,
        // employerNewMessagesCount: number,
        lastMessageDate: '08/08/2020',
        lastMessageTime: '1315',
        threadId: 'bm2ONh0ecYB501nshwIQ', //TEST FcoVsZWrCPtoE20bS4A5
    },
};

const defaultEmployerJson = {
    employers: {
        additionalSeats: 0,
        city: null,
        cityLocation: null,
        companyName: 'Holiday Inn',
        country: null,
        dateFormat: 'MM/dd/yyyy',
        language: null,
        profilePicUrl:
            'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/public%2Fimages%2Femp.png?alt=media&token=556d94a1-9d5d-4d28-a551-0e56c61ad737',
        members: [
            {
                email: null,
                firstName: null,
                inviteDt: null,
                isAdmin: true,
                isOwner: true,
                middleName: null,
                lastName: null,
                profilePicUrl:
                    'https://firebasestorage.googleapis.com/v0/b/abyss-vendor-b829d.appspot.com/o/public%2Fimages%2Femp1.png?alt=media&token=d08d4f54-3858-4af8-9f45-e7dfe0a3bde6',
                userId: null,
            },
        ],
        seatPurchasedDt: null,
        state: null,
        subscriptionDt: null,
        tier: 2, // 1, 2, or 3
        timeFormat: 'h:mm a',
        urlName: null,
    },
    memberAcceptInviteJson: {
        email: 'cleo.employer@gmail.com',
        firstName: 'Cleo',
        isAdmin: true,
        middleName: null,
        lastName: 'Employer',
        profilePicUrl: null,
        userId: 'OSeMcHYQJ6Xe7JdEhgPUeCzGhih1', //OSeMcHYQJ6Xe7JdEhgPUeCzGhih1 CB5q1F88wlXsMH5cSntVXB4j0ky2
    },
};

const defaultDynamicDocsList = [
    { field1: '111', field2: 'aaa' },
    { field1: '222', field2: 'bbb' },
    { field1: '333', field2: 'ccc' },
];

const defaultCreatableLovJson = {
    list: [
        'Abstract Writer',
        'Agricultural Agent',
        'Art Director',
        'Breakfast Cook',
        'Brewmaster',
        'Brick Maker',
        'Casino Dealer',
        'Cattle Driver',
        'Control Electrician',
        'Electrician',
        'Head Greenskeeper',
        'Housekeeping Staff',
        'Oyster Buyer',
        'Payroll Auditor',
        'Program Manager',
        'Rail Maintenance Worker',
        'Repair Department Supervisor',
        'School Bus Driver',
        'School Cook',
        'Skin Care Technician',
        'Software Engineer',
        'Special Effects Artist',
        'Telecommunication Engineer',
        'X-Ray Technician',
        'Yard Rigger',
    ],
};

// const collectionNameForEsPushOptions = ['abc', 'def', 'xyz'];
const collectionNameForEsPushOptions = [
    { label: 'OCCUPATION', value: 'OCCUPATION' },
    { label: 'INDUSTRY', value: 'INDUSTRY' },
    { label: 'OTHER_EDUCATION', value: 'OTHER_EDUCATION' },
    { label: 'SKILL_SET', value: 'SKILL_SET' },
    { label: 'JOB', value: 'JOB' },
    { label: 'EMP_PROFILE', value: 'EMP_PROFILE' },
    { label: 'EMP_JOB', value: 'EMP_JOB' },
    { label: 'JS_PROFILE', value: 'JS_PROFILE' },
    { label: 'JS_APPLIED_JOB', value: 'JS_APPLIED_JOB' },
    { label: 'JS_SAVED_JOB', value: 'JS_SAVED_JOB' },
    { label: 'MESSAGE', value: 'MESSAGE' },
    { label: 'THREAD_SUMMARIES', value: 'THREAD_SUMMARIES' },
    // { label: 'COUNTRY', value: 'COUNTRY' },
    // { label: 'STATE', value: 'STATE' },
    // { label: 'CITY', value: 'CITY' },
];

const promoCodeTypeOptions = [
    { label: '30 Days Free', value: '30D' },
    { label: '60 Days Free', value: '60D' },
    { label: '10% Discount', value: '10%' },
];

const getDefns = params => {
    const { props, promoCode, interviewListJson, snackbarMessage, snackbarErrorMessage, threadId, employerReply, data } = params;
    const {
        setInterviewListJson,
        setSnackbarMessage,
        setSnackbarErrorMessage,
        setThreadId,
        setEmployerReply,
        handleChangeData,
        handleChangeCollectionNameForEsPush,
        handleClickSetUpEmpButton,
        handleClickAddLovItemsButton,
        handleClickAddDynamicDocsButton,
        handleClickAddDynamicDataButton,
        handleClickPushCollectionToElasticSearchButton,
        handleClickPushCountriesStatesCitiesToElasticSearchFromJsonButton,
        handleClickPushEntireCollectionToElasticSearchButton,
        handleShowCloudStorageObjectListButton,
        handleShowOversizedCloudStorageObjectListButton,
        handleClickCallFunctionButton,
        handleClickSaveStripeTestClockIdButton,
        handleChangePromoCodeType,
        handleClickGeneratePromoCodeButton,
        handleClickBeginNewBillCycleButton,
        handleClickAcceptEmployerInviteButton,
        handleClickReactivateEmployerButton,
        handleClickChangePasswordButton,
        handleClickChangeEmailButton,
        handleClickSendResetPasswordEmailButton,
    } = params;

    const {
        stripeTestClockId,
        employerId,
        userId,
        memberAcceptInviteJson,
        employerJson,
        employerOwnerUserId,
        newPassword,
        newEmail,
        email,
        lovCollectionName,
        lovListJson,
        dynamicDocsCollectionPath,
        dynamicDocsJson,
        dynamicFieldDocPath,
        dynamicFieldName,
        dynamicDataJson,
        collectionName,
        collectionNameForEsPush,
        esTypeName,
        promoCodeType,
    } = data;

    // const { myMessagesJson, setMyMessagesJson } = params;

    // const { dynamicDataJson, setDynamicDataJson } = params;

    const { classes } = props;

    const defns = {
        stripeTestClockId: {
            name: 'stripeTestClockId',
            label: 'Stripe Test Clock ID',
            placeholder: 'Ex. clock_1LEFeAGGYnJdvx9wFFAflmbz',
            fullWidth: true,
            value: stripeTestClockId,
            onChange: handleChangeData,
        },
        saveStripeTestClockIdButton: { onClick: handleClickSaveStripeTestClockIdButton },
        promoCodeType: {
            name: 'promoCodeType',
            label: 'Promo Code Type',
            fullWidth: true,
            value: promoCodeType,
            options: promoCodeTypeOptions,
            onChange: handleChangePromoCodeType,
        },
        promoCode: {
            disabled: true,
            value: promoCode,
        },
        generatePromoCodeButton: {
            onClick: handleClickGeneratePromoCodeButton,
        },
        employerId: {
            name: 'employerId',
            label: 'Employer ID',
            fullWidth: true,
            value: employerId,
            onChange: handleChangeData,
        },
        beginNewBillCycleButton: {
            onClick: handleClickBeginNewBillCycleButton,
        },

        memberAcceptInviteJson: {
            name: 'memberAcceptInviteJson',
            label: 'Member JSON',
            fullWidth: true,
            multiline: true,
            value: memberAcceptInviteJson,
            onChange: handleChangeData,
        },
        acceptEmployerInviteButton: {
            onClick: handleClickAcceptEmployerInviteButton,
        },

        employerOwnerUserId: {
            name: 'employerOwnerUserId',
            label: "Owner's User ID",
            fullWidth: true,
            value: employerOwnerUserId,
            onChange: handleChangeData,
        },
        reactivateEmployerButton: {
            onClick: handleClickReactivateEmployerButton,
        },

        userId: {
            name: 'userId',
            label: 'User ID',
            fullWidth: true,
            value: userId,
            onChange: handleChangeData,
        },
        employerJson: {
            name: 'employerJson',
            label: 'Employer JSON',
            fullWidth: true,
            multiline: true,
            value: employerJson,
            onChange: handleChangeData,
        },
        setUpEmpButton: {
            onClick: handleClickSetUpEmpButton,
        },

        threadId: {
            label: 'Thread ID',
            fullWidth: true,
            value: threadId,
            onChange: handleChangeThreadId.bind(null, setThreadId),
        },
        employerReply: {
            label: 'Employer Reply',
            fullWidth: true,
            value: employerReply,
            onKeyPress: handleKeyUpReplyMessage.bind(null, threadId, setEmployerReply),
            onChange: handleChangeEmployerReply.bind(null, setEmployerReply),
        },
        sendEmployerReplyButton: {
            onClick: handleClickSendEmployerReplyButton.bind(null, threadId, employerReply, setEmployerReply, setSnackbarMessage),
        },
        threadId1: {
            variant: 'body1',
            value: 'TEST Thread 1: FcoVsZWrCPtoE20bS4A5',
        },
        threadId2: {
            variant: 'body1',
            value: 'TEST Thread 2: wK5yEJK1cU0wKblUt8rH',
        },
        threadId3: {
            variant: 'body1',
            value: 'DEV Thread 1: aHl5XlglmtTOxldDkmlO',
        },
        threadId4: {
            variant: 'body1',
            value: 'DEV Thread 2: bm2ONh0ecYB501nshwIQ',
        },
        threadId5: {
            variant: 'body1',
            value: 'LOCAL Thread 1: Af7N9YXCDbRvFsoKtykg',
        },
        threadId6: {
            variant: 'body1',
            value: 'LOCAL Thread 2: f31F3BEzaXBW8iLU0ZTp',
        },
        interviewListJson: {
            label: 'Interviews JSON',
            fullWidth: true,
            multiline: true,
            value: interviewListJson,
            onClick: handleClickInterviewListJson,
            onChange: handleChangeInterviewListJson.bind(null, setInterviewListJson),
        },
        addNewInterviewRecordsButton: {
            onClick: handleClickAddNewInterviewRecordsButton.bind(null, interviewListJson, setSnackbarMessage),
        },

        // updateCountryLovButton: {
        //     onClick: handleClickUpdateCountryLovButton.bind(null, setSnackbarMessage),
        // },
        // updateStateLovButton: {
        //     onClick: handleClickUpdateStateLovButton.bind(null, setSnackbarMessage),
        // },
        // updateCityLovButton: {
        //     onClick: handleClickUpdateCityLovButton.bind(null, setSnackbarMessage),
        // },

        // renameStatesCollectionButton: {
        //     onClick: handleClickRenameStatesCollectionButton.bind(null, setSnackbarMessage),
        // },
        // renameCitiesCollectionButton: {
        //     onClick: handleClickRenameCitiesCollectionButton.bind(null, setSnackbarMessage),
        // },

        importCountriesStatesCitiesButton: {
            onClick: handleClickImportCountriesStatesCitiesButton.bind(null, setSnackbarMessage),
        },

        clearJobRelatedDataButton: {
            onClick: handleClickClearJobRelatedDataButton.bind(null, setSnackbarMessage),
        },

        newPassword: {
            name: 'newPassword',
            label: 'New Password',
            fullWidth: true,
            value: newPassword,
            onChange: handleChangeData,
        },
        changePasswordButton: {
            onClick: handleClickChangePasswordButton.bind(null, newPassword, setSnackbarMessage),
        },

        newEmail: {
            name: 'newEmail',
            label: 'New Email',
            fullWidth: true,
            value: newEmail,
            onChange: handleChangeData,
        },
        changeEmailButton: {
            onClick: handleClickChangeEmailButton.bind(null, newEmail, setSnackbarMessage),
        },

        email: {
            name: 'email',
            label: 'Email',
            fullWidth: true,
            value: email,
            onChange: handleChangeData,
        },
        sendResetPasswordEmailButton: {
            onClick: handleClickSendResetPasswordEmailButton.bind(null, email, setSnackbarMessage),
        },

        lovCollectionName: {
            name: 'lovCollectionName',
            label: 'LOV Collection Name',
            fullWidth: true,
            value: lovCollectionName,
            onChange: handleChangeData,
        },
        lovListJson: {
            name: 'lovListJson',
            label: 'LOV Array JSON',
            fullWidth: true,
            multiline: true,
            value: lovListJson,
            onChange: handleChangeData,
        },
        addLovItemsButton: {
            onClick: handleClickAddLovItemsButton.bind(null, lovListJson, setSnackbarMessage),
        },

        dynamicDocsCollectionPath: {
            name: 'dynamicDocsCollectionPath',
            label: 'Collection Path',
            fullWidth: true,
            value: dynamicDocsCollectionPath,
            onChange: handleChangeData,
        },
        dynamicDocsJson: {
            name: 'dynamicDocsJson',
            label: 'Dynamic Docs JSON',
            fullWidth: true,
            multiline: true,
            value: dynamicDocsJson,
            onChange: handleChangeData,
        },
        addDynamicDocsButton: {
            onClick: handleClickAddDynamicDocsButton.bind(null, dynamicDocsJson, setSnackbarMessage),
        },

        dynamicFieldDocPath: {
            name: 'dynamicFieldDocPath',
            label: 'Document Path',
            fullWidth: true,
            value: dynamicFieldDocPath,
            onChange: handleChangeData,
        },
        dynamicFieldName: {
            name: 'dynamicFieldName',
            label: 'Dynamic Field Name',
            fullWidth: true,
            value: dynamicFieldName,
            onChange: handleChangeData,
        },
        dynamicDataJson: {
            name: 'dynamicDataJson',
            label: 'Dynamic Data JSON',
            fullWidth: true,
            multiline: true,
            value: dynamicDataJson,
            onChange: handleChangeData,
        },
        addDynamicDataButton: {
            onClick: handleClickAddDynamicDataButton,
        },

        collectionName: {
            name: 'collectionName',
            label: 'Collection Name',
            fullWidth: true,
            value: collectionName,
            onChange: handleChangeData,
        },
        esTypeName: {
            name: 'esTypeName',
            label: 'ElasticSearch Type',
            fullWidth: true,
            value: esTypeName,
            onChange: handleChangeData,
        },
        pushCollectionToElasticSearchButton: {
            onClick: handleClickPushCollectionToElasticSearchButton,
        },

        pushCountriesStatesCitiesToElasticSearchFromJsonButton: {
            onClick: handleClickPushCountriesStatesCitiesToElasticSearchFromJsonButton,
        },

        collectionNameForEsPush: {
            name: 'collectionNameForEsPush',
            esTypeName: 'esTypeForEsPush',
            label: 'Collection',
            fullWidth: true,
            value: collectionNameForEsPush,
            options: collectionNameForEsPushOptions,
            onChange: handleChangeCollectionNameForEsPush,
        },
        pushEntireCollectionToElasticSearchButton: {
            onClick: handleClickPushEntireCollectionToElasticSearchButton,
        },

        showCloudStorageObjectListButton: {
            onClick: handleShowCloudStorageObjectListButton,
        },
        showOversizedCloudStorageObjectListButton: {
            onClick: handleShowOversizedCloudStorageObjectListButton,
        },

        callFunctionButton: {
            onClick: handleClickCallFunctionButton,
        },
        // myMessagesJson: {
        //     label: 'My Messages JSON',
        //     fullWidth: true,
        //     multiline: true,
        //     value: myMessagesJson,
        //     onClick: handleClickMyMessagesJson,
        //     onChange: handleChangeIMyMessagesJson.bind(null, setMyMessagesJson),
        // },
        // addNewMyMessagesRecordsButton: {
        //     onClick: handleClickAddNewMyMessagesRecordsButton.bind(null, myMessagesJson, setSnackbarMessage),
        // },
        snackbar: {
            message: { successMessage: snackbarMessage, errorMessage: snackbarErrorMessage },
            onClose: handleCloseSnackbar.bind(null, setSnackbarMessage, setSnackbarErrorMessage),
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

const handleClickSendEmployerReplyButton = (threadId, employerReply, setEmployerReply, setSnackbarMessage, evt) => {
    // add new reply message to db
    const messageDto = {
        createDt: new Date(),
        senderId: 'EMPLOYER000001',
        recipientId: 'ekOVkRuQj1evtfnLsoHVfyeia632',
        threadId,
        content: employerReply,
        isEmployer: true,
    };
    addThreadMessage({ messageDto, setSnackbarMessage });
    // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', messageDto);
    clearReply(setEmployerReply);
};

const handleChangeThreadId = (setThreadId, evt) => {
    const threadId = evt.target.value;
    setThreadId(threadId);
};

const handleChangeEmployerReply = (setEmployerReply, evt) => {
    const message = evt.target.value;
    setEmployerReply(message);
};

const handleKeyUpReplyMessage = (threadId, setEmployerMessage, evt) => {
    if (evt.key === 'Enter' && !evt.shiftKey) {
        const message = evt.target.value;
        if (!_isNil(message) && message !== '') {
            evt.preventDefault();
            const messageDto = {
                createDt: new Date(),
                senderId: 'EMPLOYER000001',
                recipientId: 'ekOVkRuQj1evtfnLsoHVfyeia632',
                threadId,
                content: message,
                isEmployer: true,
            };
            addThreadMessage({ messageDto });
            // console.log('>>>>>>>>>>>>>>>>>>>>>>>>>>>>> ', messageDto);
            clearReply(setEmployerMessage);
        }
    }
};

const clearReply = setEmployerMessage => {
    setEmployerMessage('');
};

const handleClickInterviewListJson = evt => {
    if (evt.target.select instanceof Function) {
        evt.target.select();
    }
};
const handleChangeInterviewListJson = (setInterviewListJson, evt) => {
    setInterviewListJson(evt.target.value);
};
const handleClickAddNewInterviewRecordsButton = (interviewListJson, setSnackbarMessage, evt) => {
    saveInterviewList(interviewListJson, setSnackbarMessage);
};

// const handleClickUpdateCountryLovButton = (setSnackbarMessage, evt) => {
//     saveCountryList({ countryList, setSnackbarMessage });
// };

// const handleClickUpdateStateLovButton = (setSnackbarMessage, evt) => {
//     saveStateList({ stateList, countryList, setSnackbarMessage });
// };

// const handleClickUpdateCityLovButton = (setSnackbarMessage, evt) => {
//     saveCityList({ cityList, stateList, countryList, setSnackbarMessage });
// };

// const handleClickRenameStatesCollectionButton = (setSnackbarMessage, evt) => {
//     renameStatesCollection({ setSnackbarMessage });
// };
// const handleClickRenameCitiesCollectionButton = (setSnackbarMessage, evt) => {
//     renameCitiesCollection({ setSnackbarMessage });
// };

const handleClickImportCountriesStatesCitiesButton = (setSnackbarMessage, evt) => {
    importCountriesStatesCities({ setSnackbarMessage });
};

const handleClickClearJobRelatedDataButton = (setSnackbarMessage, evt) => {
    clearJobRelatedData({ setSnackbarMessage });
};

// const handleChangeDynamicDataJson = (setDynamicDataJson, evt) => {
//     setDynamicDataJson(evt.target.value);
// };
// const handleClickAddDynamicDataButton = (dynamicDataJson, setSnackbarMessage, evt) => {
//     addDynamicData({ dataJsonStr: dynamicDataJson, setSnackbarMessage });
// };

// const handleClickMyMessagesJson = evt => {
//     if (evt.target.select instanceof Function) {
//         evt.target.select();
//     }
// };
// const handleChangeIMyMessagesJson = (setMyMessagesJson, evt) => {
//     setMyMessagesJson(evt.target.value);
// };
// const handleClickAddNewMyMessagesRecordsButton = (myMessagesJson, setSnackbarMessage, evt) => {
//     saveMyMessagesThreads(myMessagesJson, setSnackbarMessage);
// };

const QuickAdmin = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const appContext = useContext(AppContext);
    const auth = _get(appContext, 'auth');
    const authUser = _get(appContext, 'authUser');
    const esToken = _get(appContext, 'esToken');
    const setEsToken = _get(appContext, 'setEsToken');

    const isSuperUser = _get(appContext, 'currentUser.superUser');

    const employerId = _get(appContext, 'employerId');
    const employerOwnerUserId = _get(appContext, 'currentEmployer.members[0].userId');
    const contextStripeTestClockId = _get(appContext, 'currentEmployer.stripeTestClockId');

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    const [promoCode, setPromoCode] = useState();
    const [interviewListJson, setInterviewListJson] = useState(JSON.stringify(defaultInterviewsJson, null, 4));
    const [myMessagesJson, setMyMessagesJson] = useState(JSON.stringify(defaultMyMessagesJson, null, 4));
    const [snackbarMessage, setSnackbarMessage] = useState();
    const [snackbarErrorMessage, setSnackbarErrorMessage] = useState();
    const [threadId, setThreadId] = useState('FcoVsZWrCPtoE20bS4A5');
    const [employerReply, setEmployerReply] = useState('');
    const [data, setData] = useState({
        employerId, //fCSshHhqJcrmbvtqZgue Qy1vHVKQQEWLFx8gV8uU Pz9g2rUyHnsRSLw46spq
        memberAcceptInviteJson: JSON.stringify(defaultEmployerJson.memberAcceptInviteJson, null, 4),
        employerOwnerUserId, //ZKZ4GcYJKqQmviCEwt98uvYd4yI3 4UvKZa2tEbhz0vRTeooenBECo3S2
        employerJson: JSON.stringify(defaultEmployerJson.employers, null, 4),
        lovCollectionName: 'occupations',
        lovListJson: JSON.stringify(defaultCreatableLovJson, null, 4),
        dynamicDocsCollectionPath: 'myTestCollection',
        dynamicDocsJson: JSON.stringify(defaultDynamicDocsList, null, 4),
        dynamicFieldDocPath: 'lovs/occupationLov',
        dynamicFieldName: 'list',
        dynamicDataJson: JSON.stringify(defaultMyMessagesJson.tiers, null, 4),
        collectionName: 'industries',
        esTypeName: 'INDUSTRY',
    });
    // const [dynamicDataJson, setDynamicDataJson] = useState('');
    // const [dynamicDataJson, setDynamicDataJson] = useState(JSON.stringify(defaultMyMessagesJson.threadSummary, null, 4));

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        setData(prev => ({ ...prev, stripeTestClockId: contextStripeTestClockId }));
    }, [contextStripeTestClockId]);

    useEffect(() => {
        if (authUser) {
            setData(prev => ({ ...prev, email: authUser?.email }));
        }
    }, [authUser]);

    //---------------------------------------------------------------------
    // Helper functions or useCallback
    //---------------------------------------------------------------------
    const handleChangeData = useCallback(
        evt => {
            const { name, value } = evt.target;
            setData({ ...data, [name]: value });
        },
        [data],
    );
    const handleChangeCollectionNameForEsPush = useCallback(
        (evt, option) => {
            const { value } = option;
            setData({ ...data, collectionNameForEsPush: value });
        },
        [data],
    );
    const handleClickSaveStripeTestClockIdButton = useCallback(
        evt => {
            const { stripeTestClockId } = data;
            saveStripeTestClockId({ employerId, stripeTestClockId, setSnackbarMessage });
        },
        [data, employerId],
    );
    const handleChangePromoCodeType = useCallback(
        (evt, option) => {
            const { value } = option;
            setData({ ...data, promoCodeType: value });
        },
        [data],
    );
    const handleClickGeneratePromoCodeButton = async evt => {
        const { promoCodeType } = data;
        const newCode = await generatePromoCode({ promoCodeType, setSnackbarMessage });
        setPromoCode(newCode);
    };
    const handleClickBeginNewBillCycleButton = useCallback(
        evt => {
            const { employerId } = data;
            beginNewBillCycle({ employerId, setSnackbarMessage });
        },
        [data],
    );
    const handleClickAcceptEmployerInviteButton = useCallback(
        evt => {
            const { employerId, memberAcceptInviteJson } = data;
            memberAcceptEmployerInvite({ employerId, memberAcceptInviteJsonStr: memberAcceptInviteJson, setSnackbarMessage });
        },
        [data],
    );
    const handleClickReactivateEmployerButton = useCallback(
        evt => {
            const { employerId, employerOwnerUserId } = data;
            reactivateEmployer({ employerId, ownerUserId: employerOwnerUserId, setSnackbarMessage });
        },
        [data],
    );
    const handleClickSetUpEmpButton = useCallback(
        evt => {
            const { userId, employerJson } = data;
            setUpEmployer({ userId, employerJson, setSnackbarMessage });
        },
        [data],
    );
    const handleClickChangePasswordButton = useCallback(
        evt => {
            const { newPassword } = data;
            changeCurrentUserPassword({ newPassword, setSnackbarMessage });
        },
        [data],
    );
    const handleClickChangeEmailButton = useCallback(
        evt => {
            const { newEmail } = data;
            changeCurrentUserEmail({ newEmail, setSnackbarMessage });
        },
        [data],
    );
    const handleClickSendResetPasswordEmailButton = useCallback(
        evt => {
            const { email } = data;
            sendResetPasswordEmail({ auth, email, setSnackbarMessage });
        },
        [data, auth],
    );
    const handleClickAddLovItemsButton = useCallback(
        evt => {
            const { lovCollectionName, lovListJson } = data;
            addCreatableLovItems({ lovCollectionName, lovListJsonStr: lovListJson, setSnackbarMessage });
        },
        [data],
    );
    const handleClickAddDynamicDocsButton = useCallback(
        evt => {
            const { dynamicDocsCollectionPath, dynamicDocsJson } = data;
            addDynamicDocs({ collectionPath: dynamicDocsCollectionPath, docsJsonStr: dynamicDocsJson, setSnackbarMessage });
        },
        [data],
    );
    const handleClickAddDynamicDataButton = useCallback(
        evt => {
            const { dynamicFieldName, dynamicFieldDocPath, dynamicDataJson } = data;
            addDynamicData({ docPath: dynamicFieldDocPath, fieldName: dynamicFieldName, dataJsonStr: dynamicDataJson, setSnackbarMessage });
        },
        [data],
    );
    const handleClickPushCollectionToElasticSearchButton = useCallback(
        evt => {
            const { collectionName, esTypeName } = data;
            pushCollectionToElasticSearch({ collectionName, esTypeName, esToken, setEsToken, setSnackbarMessage });
        },
        [data, esToken, setEsToken],
    );

    const handleClickPushCountriesStatesCitiesToElasticSearchFromJsonButton = useCallback(
        evt => {
            pushCountriesStatesCitiesToElasticSearchFromJson({ esToken, setEsToken, setSnackbarMessage });
        },
        [esToken, setEsToken],
    );

    const handleClickPushEntireCollectionToElasticSearchButton = useCallback(
        evt => {
            const { collectionNameForEsPush } = data;
            const service = collectionEsSyncServices[collectionNameForEsPush];
            service && service({ esToken, setEsToken, setSnackbarMessage });
        },
        [data, esToken, setEsToken],
    );

    const handleShowCloudStorageObjectListButton = useCallback(() => {
        showCloudStorageObjectList({});
    }, []);
    const handleShowOversizedCloudStorageObjectListButton = useCallback(() => {
        showCloudStorageObjectList({ showOversizedOnly: true });
    }, []);

    const handleClickCallFunctionButton = useCallback(() => {
        // alert('do nothing');
        // populateEngagementFields({ setSnackbarMessage });
        // fixJsEngageCounts({ setSnackbarMessage });
        // populateSurveyFields({ setSnackbarMessage });
        // generateMonthHiredCandidates({ setSnackbarMessage });
        // populateAppliedJobs({ setSnackbarMessage });
        // populateAdWidthCustomers({ setSnackbarMessage });
        // populateInterviews({ setSnackbarMessage });
        // populateFeedbacks({ setSnackbarMessage });
        // fetchCreatableLovCollection({ setSnackbarMessage });
        // fixDashboardActionNeededPendingInterviews({ setSnackbarMessage });
        sendWaitListEmails({ setSnackbarMessage });
    }, []);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    if (isSuperUser !== true && process.env.REACT_APP_ENV === 'PROD') return <PageMessage userNoAccess />;
    const defns = getDefns({
        props,
        promoCode,
        interviewListJson,
        setInterviewListJson,
        myMessagesJson,
        setMyMessagesJson,
        snackbarMessage,
        setSnackbarMessage,
        snackbarErrorMessage,
        setSnackbarErrorMessage,
        threadId,
        setThreadId,
        employerReply,
        setEmployerReply,
        data,
        setData,
        handleChangeData,
        handleChangeCollectionNameForEsPush,
        handleClickSetUpEmpButton,
        handleClickAddLovItemsButton,
        handleClickAddDynamicDocsButton,
        handleClickAddDynamicDataButton,
        handleClickPushCollectionToElasticSearchButton,
        handleClickPushCountriesStatesCitiesToElasticSearchFromJsonButton,
        handleClickPushEntireCollectionToElasticSearchButton,
        handleShowCloudStorageObjectListButton,
        handleShowOversizedCloudStorageObjectListButton,
        handleClickCallFunctionButton,
        handleClickSaveStripeTestClockIdButton,
        handleChangePromoCodeType,
        handleClickGeneratePromoCodeButton,
        handleClickBeginNewBillCycleButton,
        handleClickAcceptEmployerInviteButton,
        handleClickReactivateEmployerButton,
        handleClickChangePasswordButton,
        handleClickChangeEmailButton,
        handleClickSendResetPasswordEmailButton,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <SimpleBar style={{ height: '100%' }}>
            <div {...defns.root}>
                <AfitdTypography variant="h5">TEMP Jitsi Meeting</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <JoinInterviewButtonTEMP onClick={() => {}} {...defns.joinInterviewButton} />
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Stripe Test Clock ID</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.stripeTestClockId} />
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.saveStripeTestClockIdButton}>
                        Save ID
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Generate Promo Code</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdAutocomplete {...defns.promoCodeType} />
                </div>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.promoCode} />
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.generatePromoCodeButton}>
                        Generate Code
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Start New Billing Cycle</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.employerId} />
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.beginNewBillCycleButton}>
                        Begin New Billing Cycle
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Member accepts employer invite</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.employerId} />
                </div>
                <div {...defns.fieldContainer}>
                    <SimpleBar style={{ maxHeight: '150px', paddingTop: '10px' }}>
                        <AfitdTextField {...defns.memberAcceptInviteJson} />
                    </SimpleBar>
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.acceptEmployerInviteButton}>
                        Accept Employer Invite
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Reactivate Cancelled Employer</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.employerId} />
                </div>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.employerOwnerUserId} />
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.reactivateEmployerButton}>
                        Reactivate
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Set Up New Employer Owner</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.userId} />
                </div>
                <div {...defns.fieldContainer}>
                    <SimpleBar style={{ maxHeight: '500px', paddingTop: '10px' }}>
                        <AfitdTextField {...defns.employerJson} />
                    </SimpleBar>
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.setUpEmpButton}>
                        Set Up Employer
                    </Button>
                </div>

                {/* <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.threadId} />
                    <br />
                    <br />
                    <AfitdTextField {...defns.employerReply} />
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.sendEmployerReplyButton}>
                        Send Employer Reply
                    </Button>
                </div>
                <div {...defns.threadIdContainer}>
                    <AfitdTypography {...defns.threadId1} />
                    <AfitdTypography {...defns.threadId2} />
                    <AfitdTypography {...defns.threadId3} />
                    <AfitdTypography {...defns.threadId4} />
                    <AfitdTypography {...defns.threadId5} />
                    <AfitdTypography {...defns.threadId6} />
                </div> */}

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Add New Interview</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <SimpleBar style={{ height: '500px', paddingTop: '10px' }}>
                        <AfitdTextField {...defns.interviewListJson} />
                    </SimpleBar>
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.addNewInterviewRecordsButton}>
                        Add New Interview Records
                    </Button>
                </div>

                {/* <div {...defns.fieldContainer} style={{ marginTop: '40px' }}>
                    Update Countries and States
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.updateCountryLovButton}>
                        Update Country LOV
                    </Button>
                    <Button variant="contained" color="primary" {...defns.updateStateLovButton}>
                        Update State LOV
                    </Button>
                    <Button variant="contained" color="primary" {...defns.updateCityLovButton}>
                        Update City LOV
                    </Button>
                </div> */}

                {/* <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.renameStatesCollectionButton}>
                        Rename States Collection to Countries
                    </Button>
                    <Button variant="contained" color="primary" {...defns.renameCitiesCollectionButton}>
                        Rename Cities Collection to States
                    </Button>
                </div> */}

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Import Countries/States/Cities from JSON</AfitdTypography>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.importCountriesStatesCitiesButton}>
                        Import Countries/States/Cities
                    </Button>
                    <br />
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Clear All Job-Related Data (fields and collections)</AfitdTypography>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.clearJobRelatedDataButton}>
                        Clear Job-Related Data
                    </Button>
                    <br />
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Change Current User Password</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.newPassword} />
                    Current user: {authUser?.email}
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.changePasswordButton}>
                        Change password
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Change Current User Email</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.newEmail} />
                    Current user: {authUser?.email}
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.changeEmailButton}>
                        Change Email
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Send Reset Password Email</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.email} />
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.sendResetPasswordEmailButton}>
                        Send Email
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Add Creatable LOV Items</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.lovCollectionName} />
                </div>
                <div {...defns.fieldContainer}>
                    <SimpleBar style={{ height: '500px', paddingTop: '10px' }}>
                        <>
                            <AfitdTextField {...defns.lovListJson} />
                            Note: It does not handle timestamp/geopoint fields yet.
                        </>
                    </SimpleBar>
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.addLovItemsButton}>
                        Add to LOV Collection
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Add New Document(s)</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.dynamicDocsCollectionPath} />
                </div>
                <div {...defns.fieldContainer}>
                    <SimpleBar style={{ height: '300px', paddingTop: '10px' }}>
                        <>
                            <AfitdTextField {...defns.dynamicDocsJson} />
                            Note: It does not handle timestamp/geopoint fields yet.
                        </>
                    </SimpleBar>
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.addDynamicDocsButton}>
                        Add dynamic document(s)
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Update One Field (Any Level Document)</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.dynamicFieldDocPath} />
                </div>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.dynamicFieldName} />
                </div>
                <div {...defns.fieldContainer}>
                    <SimpleBar style={{ height: '500px', paddingTop: '10px' }}>
                        <>
                            <AfitdTextField {...defns.dynamicDataJson} />
                            Note: It does not handle timestamp/geopoint fields yet.
                        </>
                    </SimpleBar>
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.addDynamicDataButton}>
                        Add dynamic data
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Push Collection to ElasticSearch</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.collectionName} />
                </div>
                <div {...defns.fieldContainer}>
                    <AfitdTextField {...defns.esTypeName} />
                    Note: It is only for records with doc.id as id.
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.pushCollectionToElasticSearchButton}>
                        Push to ElasticSearch
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Push Countries/States/Cities to ElasticSearch from JSON</AfitdTypography>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.pushCountriesStatesCitiesToElasticSearchFromJsonButton}>
                        Push Countries/States/Cities
                    </Button>
                    <br />
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Push Entire Collection to ElasticSearch</AfitdTypography>
                <div {...defns.fieldContainer}>
                    <AfitdAutocomplete {...defns.collectionNameForEsPush} />
                    Note: It is only for records with doc.id as id.
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.pushEntireCollectionToElasticSearchButton}>
                        Push to ElasticSearch
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">List All Cloud Storage Objects</AfitdTypography>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.showCloudStorageObjectListButton}>
                        Show All Objects
                    </Button>
                    &nbsp;&nbsp;
                    <Button variant="contained" color="primary" {...defns.showOversizedCloudStorageObjectListButton}>
                        Show Oversized Objects (&gt; 400kB)
                    </Button>
                </div>

                <br />
                <br />
                <br />
                <AfitdTypography variant="h5">Call Any Function</AfitdTypography>
                <div {...defns.fieldContainer}>WARNING: Before clicking it, check the code to see which function it is calling.</div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.callFunctionButton}>
                        Call Function
                    </Button>
                </div>

                {/* <div {...defns.fieldContainer}>
                    <SimpleBar style={{ height: '500px' }}>
                        <AfitdTextField {...defns.myMessagesJson} />
                    </SimpleBar>
                </div>
                <div {...defns.buttonContainer}>
                    <Button variant="contained" color="primary" {...defns.addNewMyMessagesRecordsButton}>
                        Add New My Messages Records
                    </Button>
                </div> */}
                <AfitdSnackbar {...defns.snackbar} />
            </div>
        </SimpleBar>
    );
};

export default withStyles(styles)(QuickAdmin);
